import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import BASE_URL from "api/Api";
import "assets/theme/admin_form.css";

const UpdateSectionHero = () => {

  const { hero_id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: null,
  });

  const [existingImage, setExistingImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchHero = async () => {
    try {
      const res = await apiFetch(
        `leader_admin/get_all_hero_section_by_id/${hero_id}`
      );

      const hero = res.data;
      console.log(hero);

      setFormData({
        title: hero.title,
        description: hero.description,
        image: null,
      });

      setExistingImage(hero.image_url);

    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    fetchHero();
  }, [hero_id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image") {
      setFormData({ ...formData, image: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      data.append("title", formData.title);
      data.append("description", formData.description);
      if (formData.image) {
        data.append("image", formData.image);
      }

      await apiFetch(
        `leader_admin/update_hero_section_by_type/${hero_id}`,
        {
          method: "PUT",
          body: data,
        }
      );

      alert("हीरो विभाग यशस्वीरित्या अपडेट झाला");
      navigate("/section_hero_list");

    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                ✏️ पृष्ठ मुख्य विभाग संपादन (Edit Section Hero Banner)
              </h4>
              <small className="text-white-50">Update section hero details</small>
            </div>
          </div>

          <Link to="/section_hero_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Hero List
          </Link>
        </div>

        {/* Form Card */}
        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">

            <form onSubmit={handleSubmit}>
              <div className="row g-4">

                {/* Title */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    शीर्षक <span className="text-muted fw-normal">(ऐच्छिक / Optional)</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                  />
                </div>

                {/* Description */}
                <div className="col-12">
                  <label className="form-label fw-semibold">
                    वर्णन <span className="text-muted fw-normal">(ऐच्छिक / Optional)</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                {/* Existing Image */}
                {existingImage && (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      सध्याची प्रतिमा
                    </label>
                    <div className="border rounded-3 p-2 shadow-sm">
                      <img
                        src={`${BASE_URL}/${existingImage}`}
                        alt="Current"
                        className="img-fluid rounded-3"
                        style={{ maxHeight: "200px", objectFit: "cover" }}
                      />
                    </div>
                  </div>
                )}

                {/* Replace Image */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold d-flex align-items-center justify-content-between">
                    <span>नवीन प्रतिमा बदला / Replace Image <span className="text-danger">*</span></span>
                    <span className="badge bg-danger text-white fw-bold px-2 py-1" style={{ fontSize: "0.75rem" }}>
                      प्रतिमा आवश्यक आहे (Required *)
                    </span>
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    name="image"
                    onChange={handleChange}
                    required={!existingImage}
                  />
                  <small className="text-danger fw-semibold d-block mt-1">
                    * बॅनरसाठी प्रतिमा असणे अनिवार्य आहे (Image is required).
                  </small>
                </div>

              </div>

              {/* Submit */}
              <div className="mt-4 text-end">
                <button
                  className="btn btn-primary px-5"
                  style={{ fontSize: "0.85rem" }}
                  disabled={loading}
                >
                  {loading ? "अपडेट होत आहे..." : "अपडेट करा"}
                </button>
              </div>

            </form>

          </div>
        </div>

      </div>
    </DashboardLayout>
  );
};

export default UpdateSectionHero;